// extracted by mini-css-extract-plugin
export default {"productDescription":"Cba-z","featuredDescription":"Dba-z","description":"Eba-z","more":"Fba-z","descriptionSku":"Gba-z"};